(() => {
  'use strict';
  const dialog = document.getElementById('MjsDiamondPromo');
  if (!dialog || dialog.dataset.initialised || typeof dialog.showModal !== 'function') return;
  dialog.dataset.initialised = 'true';
  const start = Date.parse(dialog.dataset.start);
  const end = Date.parse(dialog.dataset.end);
  // Confirmed product slots from the landing-page template, checked by build.mjs.
  // Keep Brisbane's fixed +10:00 offset, including through the October DST change.
  const revealStrings = (dialog.dataset.reveals || '').split(',').filter(Boolean);
  const reveals = revealStrings.map(value => /T07:00:00\+10:00$/.test(value) ? Date.parse(value) : NaN);
  const scheduleValid = reveals.length > 0 && reveals.every((value, index) =>
    Number.isFinite(value) && value >= start && value < end && (!index || value > reveals[index - 1]));
  const countdown = dialog.querySelector('[data-promo-countdown]');
  const countdownLabel = dialog.querySelector('[data-promo-countdown-label]');
  const clock = dialog.querySelector('[data-promo-countdown-clock]');
  const readable = dialog.querySelector('[data-promo-countdown-readable]');
  let countdownTimer;
  const renderCountdown = () => {
    window.clearTimeout(countdownTimer);
    if (!dialog.open || document.hidden || !countdown || !clock || !readable || !countdownLabel) return;
    const now = Date.now();
    const nextScheduled = reveals.find(value => value > now);
    const lastReveal = reveals[reveals.length - 1];
    const finalDayConfirmed = lastReveal < end && end - lastReveal <= 86400000;
    const target = scheduleValid && now < end ? nextScheduled || (finalDayConfirmed ? end : undefined) : undefined;
    countdown.dataset.state = now >= end ? 'ended' : !scheduleValid ? 'static' : target ? now < start ? 'upcoming' : 'live' : 'awaiting-schedule';
    countdown.dataset.target = target ? new Date(target).toISOString() : '';
    // With no scheduled reveal, the collection CTA is the only invitation.
    countdown.hidden = !target;
    clock.hidden = !target;
    if (!target) {
      countdownLabel.textContent = '';
      readable.textContent = '';
      return;
    }
    const upcoming = now < start;
    countdownLabel.textContent = upcoming ? 'First daily reveal in' : target === end ? 'The Diamond Drop ends in' : 'Next reveal in';
    const remaining = Math.max(0, Math.ceil((target - now) / 1000));
    const values = {
      days: Math.floor(remaining / 86400),
      hours: upcoming ? Math.floor(remaining % 86400 / 3600) : Math.floor(remaining / 3600),
      minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60
    };
    dialog.querySelector('[data-promo-days-unit]').hidden = !upcoming;
    for (const [unit, value] of Object.entries(values)) dialog.querySelector(`[data-promo-${unit}]`).textContent = String(value).padStart(2, '0');
    const minuteKey = `${target}:${Math.floor(remaining / 60)}`;
    if (readable.dataset.minute !== minuteKey) {
      readable.dataset.minute = minuteKey;
      readable.textContent = `${countdownLabel.textContent} ${upcoming ? values.days + ' days, ' : ''}${values.hours} hours and ${values.minutes} minutes. Revealed daily at 7:00 am AEST. The Drop price remains until sold.`;
    }
    // Recalculate from wall time; never drift by decrementing a cached counter.
    countdownTimer = window.setTimeout(renderCountdown, Math.max(100, 1000 - now % 1000 + 20));
  };
  new MutationObserver(renderCountdown).observe(dialog, {attributes: true, attributeFilter: ['open']});
  document.addEventListener('visibilitychange', renderCountdown);
  window.addEventListener('pageshow', renderCountdown);
  const sessionKey = 'mjsDiamondPromo:2026:shown';
  let shown = false;
  let timer;
  let previousOverflow = '';
  let previousFocus;
  const seen = () => {
    try { return shown || sessionStorage.getItem(sessionKey) === 'true'; }
    catch { return shown; }
  };
  const markShown = () => {
    shown = true;
    try { sessionStorage.setItem(sessionKey, 'true'); } catch { /* In-memory fallback. */ }
  };
  const restorePage = () => {
    markShown();
    document.body.style.overflow = previousOverflow;
    if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
  };
  const close = () => {
    if (!dialog.open) return;
    dialog.close();
    restorePage();
  };
  dialog.querySelector('button').addEventListener('click', close);
  dialog.querySelector('a').addEventListener('click', () => { markShown(); close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab' || !dialog.open) return;
    const controls = [...dialog.querySelectorAll('button, a[href]')].filter(element => !element.disabled && element.getClientRects().length);
    if (!controls.length) return;
    const index = controls.indexOf(document.activeElement);
    const next = (index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    event.preventDefault();
    controls[next].focus();
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => {
    if (!dialog.open) restorePage();
  });
  if (dialog.dataset.enabled !== 'true' || location.pathname.replace(/\/+$/, '') !== '' || !Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
  const open = () => {
    if (seen() || document.hidden || Date.now() < start || Date.now() >= end) return;
    // Leave an existing cart, consent or other modal alone. Never stack dialogs.
    const otherDialog = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(element => element !== dialog && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    if (otherDialog) return;
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    renderCountdown();
    document.body.style.overflow = 'hidden';
    markShown();
    timer = window.setTimeout(schedule, Math.min(end - Date.now(), 2147483647));
  };
  const schedule = () => {
    window.clearTimeout(timer);
    if (Date.now() >= end) { close(); return; }
    if (dialog.open) {
      timer = window.setTimeout(schedule, Math.min(end - Date.now(), 2147483647));
      return;
    }
    if (seen() || document.hidden) return;
    const untilStart = Math.max(0, start - Date.now());
    timer = window.setTimeout(untilStart ? schedule : open, Math.min(untilStart || 6000, 2147483647));
  };
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
